import {Endpoint} from '@eryxcoop/appyx-comm';

export default class AssignLeadEndpoint extends Endpoint {
    adaptValues(leadAssignment) {
        return {
            lead_id: leadAssignment.leadId,
            responsible_email: leadAssignment.responsibleEmail,
        };
    }
}
